define('rebrush/components/blocks/image-comparer',[
    'jquery',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'lodash'
], function(
    $,
    Component,
    BEM,
    _
) {
    var BLOCK_NAME = 'image-comparer';

    function Comparer(block) {
        this.block = BEM.block(block);
        this.$refs = {
            leftImage: this.block.getElements('left-image'),
            rightImage: this.block.getElements('right-image'),
            controls: this.block.getElements('controls'),
            container: this.block.getElements('container')
        };
        this.moveCallback = _.bind(this.updateSliderPosition, this);
        this.positionPct = 0.5;
        this.imageWidth = 0;
        this.hover = false;
        this.bindEvents();
    }

    Comparer.prototype = {
        bindEvents: function() {
            $(window).on('resize', _.debounce(_.bind(this.getAndSetImageWidth, this), 100));

            // for mobile
            this.$refs.container.on('touchstart', _.bind(this.startSliding, this));
            window.addEventListener && window.addEventListener('touchend', _.bind(this.finishSliding, this));

            // for desktop
            if (this.hover) {
                this.$refs.container.on('mouseenter', _.bind(this.startSliding, this));
                this.$refs.container.on('mouseleave', _.bind(this.finishSliding, this));
            } else {
                this.$refs.container.on('mousedown', _.bind(this.startSliding, this));
                $(window).on('mouseup', _.bind(this.finishSliding, this));
            }
        },

        getAndSetImageWidth: function() {
            this.imageWidth = this.$refs.rightImage.get(0).getBoundingClientRect().width;

            var leftImageStyle = {
                clip:
                    'rect(auto, ' +
                    this.imageWidth * this.positionPct +
                    'px, auto, auto)',
            };
            var controlsStyle = {
                cursor: !this.hover && 'ew-resize',
                'margin-left': this.imageWidth * this.positionPct + 'px'
            };

            this.$refs.leftImage.css(leftImageStyle);
            this.$refs.controls.css(controlsStyle);
        },
        startSliding: function(event) {
            // Prevent default behavior other than mobile scrolling
            if (!('touches' in event)) {
                event.preventDefault();
            }
            // Slide the image even if you just click or tap (not drag)
            this.updateSliderPosition(event);

            $(window).on('mousemove', this.moveCallback);
            window.addEventListener && window.addEventListener('touchmove', this.moveCallback);
        },
        finishSliding: function() {
            $(window).off('mousemove', this.moveCallback);
            window.addEventListener && window.removeEventListener('touchmove', this.moveCallback);
        },
        updateSliderPosition: function(event) {
            var e = event || window.event;

            // Calc Cursor Position from the left edge of the viewport
            var cursorXfromViewport = e.touches ? e.touches[0].pageX : e.pageX;

            // Calc Cursor Position from the left edge of the window (consider any page scrolling)
            var cursorXfromWindow = cursorXfromViewport - window.pageXOffset;

            // Calc Cursor Position from the left edge of the image
            var imagePosition = this.$refs.rightImage.get(0).getBoundingClientRect();
            var pos = cursorXfromWindow - imagePosition.left;

            // Set minimum and maximum values ​​to prevent the slider from overflowing
            var minPos = 0;
            var maxPos = this.imageWidth - 2;

            if (pos < minPos) {
                pos = minPos;
            }

            if (pos > maxPos) {
                pos = maxPos;
            }

            this.positionPct = pos / this.imageWidth;
            this.getAndSetImageWidth();
        }
    };

    return Component.create({
        $init: function() {
            BEM.block(BLOCK_NAME).each(function() {
                new Comparer(this);
            });
        }
    });
});
